import { render, staticRenderFns } from "./RejectExtensionModal.vue?vue&type=template&id=2b0eb654&scoped=true&"
import script from "./RejectExtensionModal.vue?vue&type=script&lang=js&"
export * from "./RejectExtensionModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectExtensionModal.vue?vue&type=style&index=0&id=2b0eb654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0eb654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0eb654')) {
      api.createRecord('2b0eb654', component.options)
    } else {
      api.reload('2b0eb654', component.options)
    }
    module.hot.accept("./RejectExtensionModal.vue?vue&type=template&id=2b0eb654&scoped=true&", function () {
      api.rerender('2b0eb654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/RejectExtensionModal.vue"
export default component.exports